export interface CaliberProps {
  id: string;
  imgUrl: string;
}
interface CaliberGroupTypes {
  [key: string]: CaliberProps[];
}
function createCaliber(id: string, imgUrl: string): CaliberProps {
  return { id, imgUrl };
}

export const CaliberGroup: CaliberGroupTypes = {
  chronographs: [
    createCaliber('breitlingCaliber01', '/breitling-caliber-01.jpg'),
    createCaliber('caliberB02', '/caliber-b02-3.jpg'),
    createCaliber('caliberB03', '/caliber-b03.jpg'),
    createCaliber('caliberB04', '/caliber-b04.jpg'),
    createCaliber('caliberB05', '/caliber-b05.jpg'),
    createCaliber('caliberB09', '/caliber-b09-2.jpg'),
    createCaliber('caliberB12', '/caliber-b12.jpg'),
    createCaliber('caliberB15', '/caliber-b15-2.jpg'),
    createCaliber('caliberB19', '/caliber-b19.jpg'),
    createCaliber('caliberB21', '/caliber-b21.png'),
    createCaliber('caliberB25', '/caliber-b25.png'),
  ],
  threeHands: [
    createCaliber('caliberB20', '/caliber-b20-2.jpg'),
    createCaliber('caliberB31', '/caliber-b31.png'),
    createCaliber('caliberB35', '/caliber-b35-2.jpg'),
  ],
  superquartz: [
    createCaliber('caliberB50', '/caliber-b50.jpg'),
    createCaliber('caliberB55', '/caliber-b55.jpg'),
    createCaliber('caliberB70', '/caliber-b70-back.jpg'),
  ],
  nonManufacture: [
    createCaliber('caliber10', '/caliber-10.png'),
    createCaliber('caliber13', '/caliber-13.png'),
    createCaliber('caliber17', '/caliber-17.png'),
    createCaliber('caliber19', '/caliber-19.png'),
    createCaliber('caliber23', '/caliber-23.png'),
    createCaliber('caliber24', '/caliber-24.png'),
    createCaliber('caliber25', '/caliber-25.png'),
    createCaliber('caliber32', '/caliber-32.png'),
    createCaliber('caliber41', '/caliber-41-2.png'),
    createCaliber('caliber77', '/caliber-77-2.png'),
    createCaliber('caliber82', '/caliber-82-2.png'),
  ],
};
